import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export const ReminderSettings = () => {
  const [s, setS] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/reminders/settings").then((r) => { setS(r.data); setEmail(r.data.email); }).catch((e) => toast.error(errMsg(e)));
  }, []);

  const save = async (patch = {}) => {
    setBusy(true);
    try {
      const { data } = await api.put("/reminders/settings", { email, enabled: s.enabled, ...patch });
      setS(data);
      toast.success("Reminder settings saved");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  if (!s) return null;
  return (
    <div className="mt-14 bg-[#F4EFE6] border border-[#E2D9CC] p-6 sm:p-8 grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-6 items-end" data-testid="reminder-settings">
      <div>
        <div className="flex items-center gap-3 mb-3">
          <Mail className="w-5 h-5 text-[#C59B27]" strokeWidth={1.4} />
          <p className="eyebrow">Update reminders</p>
        </div>
        <p className="text-sm text-[#1C181D] max-w-2xl">An email goes out <b>{s.pre_days} days before</b> each guide's 6-month update date, and again <b>on the due date</b>. Each email has a one-click link that starts the update. The check runs every day at 8am Sydney time.</p>
        {s.last_run && <p data-testid="reminder-last-run" className="text-xs text-[#8C827A] mt-2">Last check {new Date(s.last_run.at).toLocaleString("en-AU")} · {s.last_run.sent ?? 0} sent</p>}
      </div>
      <div className="flex items-center gap-3">
        <label className="flex items-center gap-2 text-sm text-[#3B1B48] mr-2">
          <Switch data-testid="reminder-enabled-toggle" checked={s.enabled} onCheckedChange={(v) => { setS({ ...s, enabled: v }); save({ enabled: v }); }} />On
        </label>
        <Input data-testid="reminder-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 w-72 bg-white rounded-none" />
        <Button data-testid="reminder-email-save-button" onClick={() => save()} disabled={busy} className="h-11 rounded-none">Save</Button>
      </div>
    </div>
  );
};
